import apiRequest from 'client/helpers/apiRequest';
import PublicationsPage, { Publication } from '@interfaces/publications-page';
import PublicationFilters from '@interfaces/publication-filters';
import { PublicationRequestParams } from '@interfaces/publication-request-params';

export const fetchPublicationsPage = (requestParams: PublicationRequestParams) => {
    const { page: pageNumber = 1, pageSize = 5, year, themeSlug } = requestParams;

    const params: any = { pageNumber, pageSize };
    if (year) {
        params.year = year;
    }

    if (themeSlug) {
        params.themeSlug = themeSlug;
    }

    return apiRequest.get<PublicationsPage>('/api/publications', { params });
};

export const fetchPublicationsByResearcherPage = (id: number, pageNumber: number = 1, pageSize: number = 5) =>
    apiRequest.get<PublicationsPage>(`/api/researchers/${id}/publications`, { params: { pageNumber, pageSize } });

export const fetchPublication = (id: number) =>
    apiRequest.get<Publication>(`/api/publications/${id}`);

export const fetchPublicationYears = (themeSlug?: string) =>
    apiRequest.get<PublicationFilters>('/api/publications/filters', { params: { themeSlug } });
